import * as React from 'react';

import { AddToast, FormErrors } from '../../../types/airframe';
import { TravelerChangePasswordValues } from '../../../types/travelerProfileForm';
import styles from './changePasswordForm.module.css';
import {
  Box,
  Button,
  Flex,
  Form,
  PasswordField,
  Text,
  TextInput,
  getTheme,
  thc,
} from '@flightstats/airframe-react';

interface ChangePasswordFormProps {
  passwordValidation: (password: string) => string | boolean;
  disabled: boolean;
  onSubmit: (errors: FormErrors, values: TravelerChangePasswordValues, addToast: AddToast) => void;
  addToast: AddToast;
}

const FormSection = thc(Box, {
  mt: '25px',
});

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  passwordValidation,
  disabled,
  onSubmit,
  addToast,
}) => {
  return (
    <Form
      onSubmit={(errors : FormErrors, values : TravelerChangePasswordValues, e : any) => {
        e.event.preventDefault(); // Needed for submitOnEnter
        onSubmit(errors, values, addToast);
      }}
      submitOnEnter
    >
      <FormSection>
        <PasswordField required validate={passwordValidation}>
          
            <TextInput
              autoFocus
              id="currentPassword"
              label="Current Password"
              type="password"
              disabled={disabled}
            />
          
        </PasswordField>
      </FormSection>

      <FormSection>
        <Box className={styles.sectionBox}>
          <Box className={styles.paddingBottom}>
            <Text>
              A new password must be at least eight characters long. It can use
              numbers, letters, and special characters.
            </Text>
          </Box>

          <PasswordField required validate={passwordValidation}>
            
              <TextInput
                id="newPassword"
                label="New Password"
                type="password"
                disabled={disabled}
              />
            
          </PasswordField>

          <PasswordField for="newPassword">
            
              <TextInput
                id="confirmPassword"
                label="Confirm Password"
                type="password"
                disabled={disabled}
              />
            
          </PasswordField>
        </Box>
      </FormSection>

      <FormSection>
        <Flex className={styles.flexColumnCenter}>
          <Button disabled={disabled} type="submit">
            Update Password
          </Button>
        </Flex>
      </FormSection>
    </Form>
  );
};